module.exports = __webpack_public_path__ + "img/product_102.7ed8398.webp";